export enum ECounterType {
  BookingWidget = 'booking_widget',
  TopUpBalance = 'top_up_balance',
}
